import singleSpaVue from "single-spa-vue";
import Vue from 'vue';
import App from './App.vue';

import {lang} from './lang';

Vue.prototype.lang = lang['ja'];

Vue.config.productionTip = false;

const vueOptions = {
    el: "#single-page",
    render: h => h(App)
};

if (!window.singleSpaNavigate) { // 如果不是single-spa模式
    delete vueOptions.el;
    new Vue(vueOptions).$mount('#single-page');
}

const vueLifecycles = singleSpaVue({
    Vue,
    appOptions: vueOptions
});

// 导出生命周期对象
export const bootstrap = vueLifecycles.bootstrap; // 启动时
export const mount = vueLifecycles.mount; // 挂载时
export const unmount = vueLifecycles.unmount; // 卸载时


export default vueLifecycles;
